import { render, staticRenderFns } from "./invitedKioskRegistration.vue?vue&type=template&id=03eadca8"
import script from "./invitedKioskRegistration.vue?vue&type=script&lang=js"
export * from "./invitedKioskRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports